import {
  UNSPECIFIED_MEMBER_ID,
  UNSPECIFIED_PAYER_NAME,
  UNSPECIFIED_RX_MEMBER_ID
} from "../../../../../../constant/coverages";

const UNSPECIFIED_PREFIXES = [UNSPECIFIED_PAYER_NAME, UNSPECIFIED_MEMBER_ID, UNSPECIFIED_RX_MEMBER_ID];

const cleanUnspecifiedValue = (str) =>
  !str || UNSPECIFIED_PREFIXES.some((prefix) => str.startsWith(prefix)) ? null : str;

export { cleanUnspecifiedValue };
